import React, { useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import './AffiliateLanding.scss';

import axios from 'axios';

import { useAppDispatch } from '../../app/hooks';
import { saveAffiliate } from '../../features/affiliate/affiliateSlice';
import { SERVER_URL } from "../../config";

const AffiliateLanding = () => {

  const dispatch = useAppDispatch();

  const history = useHistory();

  let { url } = (useParams() as any);

  const dispatchAffiliate = async () => {

    console.log(`Affiliate url: ${url}`)

    const affiliate: any = await axios.get(SERVER_URL + "/affiliate/url", {
      params: { url: url }
    });

    dispatch(saveAffiliate(affiliate.data));

    history.push(`/`);
  }

  useEffect(() => {
    dispatchAffiliate();
  }, [])


  return (
    <></>
  );
}

export default AffiliateLanding;

